import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import CopyToClipboard from 'react-copy-to-clipboard';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {
  Force_Logout_All_Users_Exept_Admins,
  Getalldatauserlog_forsearch,
} from '../Redux/Actions/AuthAction';
import { UsersActions } from '../Component/Auth/UsersActions';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconSearch     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconCopy       = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconEdit       = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IconKey        = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IconLogout     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
const IconAdd        = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconChevronD   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconChevronU   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="18 15 12 9 6 15"/></svg>;
const IconWarning    = () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const IconChannel    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IconCloseModal = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconSort       = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>;

/* ─── Role config ─────────────────────────────────────────────────────────── */
const ROLE_CONFIG = {
  Admin:         { color: '#ef4444', bg: 'rgba(239,68,68,0.1)',   border: 'rgba(239,68,68,0.25)',   initBg: '#ef4444' },
  Marketer:      { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)',  border: 'rgba(245,158,11,0.25)',  initBg: '#f59e0b' },
  Manager:       { color: '#22c55e', bg: 'rgba(34,197,94,0.1)',   border: 'rgba(34,197,94,0.25)',   initBg: '#22c55e' },
  'Team Leader': { color: '#3b82f6', bg: 'rgba(59,130,246,0.1)',  border: 'rgba(59,130,246,0.25)',  initBg: '#3b82f6' },
  Sales:         { color: '#a855f7', bg: 'rgba(168,85,247,0.1)',  border: 'rgba(168,85,247,0.25)',  initBg: '#a855f7' },
  Accountant:    { color: '#64748b', bg: 'rgba(100,116,139,0.1)', border: 'rgba(100,116,139,0.25)', initBg: '#64748b' },
};
const getRoleConf = (role) => ROLE_CONFIG[role] || { color: '#64748b', bg: 'rgba(100,116,139,0.1)', border: 'rgba(100,116,139,0.25)', initBg: '#64748b' };
const CHANNEL_COLORS = ['#3b82f6','#22c55e','#f59e0b','#a855f7','#ef4444','#64748b','#06b6d4','#ec4899'];

/* ─── CSS ────────────────────────────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
  .up-overlay {
    position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;
    background:rgba(0,0,0,0.7);backdrop-filter:blur(10px);animation:up-fadein 0.2s ease both;
  }
  @keyframes up-fadein{from{opacity:0}to{opacity:1}}
  .up-modal {
    width:100%;max-width:440px;margin:0 20px;border-radius:20px;
    padding:32px 28px 28px;position:relative;
    animation:up-slide 0.25s cubic-bezier(0.34,1.2,0.64,1) both;
  }
  @keyframes up-slide{from{opacity:0;transform:translateY(20px) scale(0.97)}to{opacity:1;transform:none}}
  .up-close-btn {
    position:absolute;top:14px;right:14px;
    width:30px;height:30px;border-radius:8px;border:1px solid;cursor:pointer;
    display:flex;align-items:center;justify-content:center;transition:all 0.2s;
  }
  .up-row {
    display:grid;
    align-items:center;
    transition:background 0.15s;
  }
  .up-row:hover { background: var(--row-hover); }
  .up-action-btn {
    display:inline-flex;align-items:center;justify-content:center;
    width:28px;height:28px;border-radius:7px;border:1px solid;
    cursor:pointer;background:transparent;transition:all 0.18s;
    text-decoration:none;flex-shrink:0;
  }
  .up-action-btn:hover{transform:translateY(-1px);}
  .up-spin {
    width:15px;height:15px;border-radius:50%;
    border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;
    animation:up-spin 0.7s linear infinite;display:inline-block;
  }
  @keyframes up-spin{to{transform:rotate(360deg)}}
  .up-copied-toast {
    position:fixed;bottom:28px;left:50%;transform:translateX(-50%);
    padding:10px 20px;border-radius:40px;font-size:13px;font-weight:600;
    background:#1e293b;color:#fff;z-index:9999999;
    box-shadow:0 8px 32px rgba(0,0,0,0.4);
    animation:up-toast 2s ease forwards;
  }
  @keyframes up-toast{
    0%{opacity:0;transform:translateX(-50%) translateY(8px)}
    15%{opacity:1;transform:translateX(-50%) translateY(0)}
    75%{opacity:1}
    100%{opacity:0;transform:translateX(-50%) translateY(-4px)}
  }
  .up-page-btn {
    width:30px;height:30px;border-radius:7px;border:1px solid;
    display:flex;align-items:center;justify-content:center;
    cursor:pointer;background:transparent;font-size:12px;
    font-weight:700;transition:all 0.15s;font-family:'DM Sans',sans-serif;
  }
  .up-page-btn:disabled{opacity:0.3;cursor:not-allowed;}
  .up-checkbox {
    width:16px;height:16px;border-radius:4px;cursor:pointer;accent-color:#1d4ed8;
  }
  .up-th {
    font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;
    padding:0 14px;display:flex;align-items:center;gap:5px;user-select:none;cursor:pointer;
    transition:color 0.15s;
    white-space:nowrap;
  }
  .up-th:hover{opacity:0.75;}
  .up-td { padding:0 14px; font-size:13px; overflow:hidden; }
  .up-select-sm {
    padding:7px 28px 7px 12px;border-radius:8px;font-size:12px;font-weight:600;
    outline:none;cursor:pointer;transition:border-color 0.15s;
    font-family:'DM Sans',sans-serif;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 8px center;
  }
  .up-channel-chip {
    padding:5px 10px;border-radius:7px;color:#fff;
    font-size:11px;font-weight:700;
  }
  @media(max-width:700px){
    .up-modal{padding:24px 18px 20px;}
  }
`;

let cssInjected = false;
const injectCSS = () => {
  if (cssInjected) return; cssInjected = true;
  const el = document.createElement('style'); el.innerHTML = CSS; document.head.appendChild(el);
};

/* ─── Logout Modal ───────────────────────────────────────────────────────── */
const LogoutModal = ({ isDark, onClose, onConfirm, loading }) => {
  const { createPortal } = require('react-dom');
  return createPortal(
    <div className="up-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="up-modal" style={{ background: isDark ? '#1a1f2e' : '#fff', boxShadow: '0 40px 100px rgba(0,0,0,0.35)', border: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}` }}>
        <button className="up-close-btn" onClick={onClose}
          style={{ borderColor: isDark ? '#3A4570' : '#E8EAF0', background: isDark ? '#252D4A' : '#F7F8FC', color: isDark ? '#9099c0' : '#7B829A' }}>
          <IconCloseModal />
        </button>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: isDark ? 'rgba(239,68,68,0.12)' : '#FFF3F3', border: `2px solid ${isDark ? '#5a3535' : '#FFBDBD'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', color: '#ef4444' }}>
          <IconWarning />
        </div>
        <p style={{ textAlign: 'center', fontSize: '18px', fontWeight: 700, color: isDark ? '#E4E8F5' : '#1C2340', margin: '0 0 8px', fontFamily: "'DM Sans',sans-serif" }}>Force Logout All Users?</p>
        <p style={{ textAlign: 'center', fontSize: '13px', color: '#7B829A', margin: '0 0 24px', lineHeight: 1.6, fontFamily: "'DM Sans',sans-serif" }}>
          This will immediately log out ALL users except Admins.<br />They'll need to sign in again.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} disabled={loading}
            style={{ flex: 1, padding: '12px', borderRadius: '10px', border: `1.5px solid ${isDark ? '#3A4570' : '#E8EAF0'}`, background: isDark ? '#252D4A' : '#F7F8FC', fontFamily: "'DM Sans',sans-serif", fontSize: '13px', fontWeight: 600, color: isDark ? '#E4E8F5' : '#1C2340', cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={onConfirm} disabled={loading}
            style={{ flex: 1, padding: '12px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#ef4444,#dc2626)', fontFamily: "'DM Sans',sans-serif", fontSize: '13px', fontWeight: 700, color: '#fff', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, boxShadow: '0 4px 16px rgba(239,68,68,0.3)' }}>
            {loading ? <><div className="up-spin" />Logging out…</> : <><IconLogout />Logout All</>}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const USersPage = () => {
  injectCSS();
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [loading,          setLoading]          = useState(true);
  const [searchTerm,       setSearchTerm]       = useState('');
  const [roleFilter,       setRoleFilter]       = useState('all');
  const [statusFilter,     setStatusFilter]     = useState('all');
  const [sortField,        setSortField]        = useState('role');
  const [sortDir,          setSortDir]          = useState('asc');
  const [expandedRows,     setExpandedRows]     = useState([]);
  const [selected,         setSelected]         = useState([]);
  const [showLogoutModal,  setShowLogoutModal]  = useState(false);
  const [loadingLogout,    setLoadingLogout]    = useState(true);
  const [copied,           setCopied]           = useState(false);
  const [currentPage,      setCurrentPage]      = useState(1);
  const [itemsPerPage,     setItemsPerPage]     = useState(10);

  const getallusers = async () => {
    setLoading(true);
    await dispatch(Getalldatauserlog_forsearch());
    setLoading(false);
  };
  useEffect(() => { getallusers(); }, []);

  const resalldata = useSelector((s) => s.AuthRoot.Signup);
  const EXCLUDED   = ['Default','No Sales','Default M','Default T','Default S','Deveolper','Dev'];
  const usersarray = (Array.isArray(resalldata?.data) ? resalldata.data : [])
    .filter((u) => !EXCLUDED.includes(u.name));

  const roleOrder = { Admin:1, Marketer:2, Manager:3, 'Team Leader':4, Sales:5, Accountant:6 };

  const handleSort = (field) => {
    if (sortField === field) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortField(field); setSortDir('asc'); }
  };

  const filteredUsers = usersarray
    .filter((u) => {
      const s = searchTerm.toLowerCase();
      const matchSearch = u.name?.toLowerCase().includes(s) || u.email?.toLowerCase().includes(s);
      const matchRole   = roleFilter === 'all' || u.role === roleFilter;
      const matchStatus = statusFilter === 'all' || (statusFilter === 'active' ? u.active : !u.active);
      return matchSearch && matchRole && matchStatus;
    })
    .sort((a, b) => {
      let va, vb;
      if (sortField === 'role')  { va = roleOrder[a.role]||99; vb = roleOrder[b.role]||99; return sortDir==='asc' ? va-vb : vb-va; }
      if (sortField === 'name')  { va = a.name||''; vb = b.name||''; }
      if (sortField === 'email') { va = a.email||''; vb = b.email||''; }
      if (sortField === 'status'){ va = a.active?0:1; vb = b.active?0:1; return sortDir==='asc' ? va-vb : vb-va; }
      return sortDir==='asc' ? va?.localeCompare(vb) : vb?.localeCompare(va);
    });

  const totalPages   = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex   = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);
  const uniqueRoles  = ['Admin','Marketer','Manager','Team Leader','Sales','Accountant'];

  const clearFilters = () => { setSearchTerm(''); setRoleFilter('all'); setStatusFilter('all'); setCurrentPage(1); };
  const hasFilters   = searchTerm || roleFilter !== 'all' || statusFilter !== 'all';

  const allSelected  = currentUsers.length > 0 && currentUsers.every(u => selected.includes(u._id));
  const toggleAll    = () => allSelected ? setSelected(s => s.filter(id => !currentUsers.some(u => u._id===id))) : setSelected(s => [...new Set([...s, ...currentUsers.map(u=>u._id)])]);
  const toggleOne    = (id) => setSelected(s => s.includes(id) ? s.filter(x=>x!==id) : [...s, id]);

  const LogoutAllUsers = async () => {
    setLoadingLogout(true);
    await dispatch(Force_Logout_All_Users_Exept_Admins());
    setLoadingLogout(false);
  };
  const reslogoutall = useSelector((s) => s.AuthRoot.logoutallusers);
  useEffect(() => {
    if (loadingLogout === false) {
      const status = reslogoutall?.data?.status;
      if (status === 'success') { Notify('success','All users logged out successfully','success'); setShowLogoutModal(false); }
      else Notify('error','Failed to logout users','error');
      setLoadingLogout(true);
    }
  }, [loadingLogout]);

  /* ── style helpers ── */
  const C = {
    bg:       isDark ? '#0f1117' : '#f4f6f9',
    card:     isDark ? '#1a1f2e' : '#ffffff',
    border:   isDark ? '#252d45' : '#e8edf5',
    text:     isDark ? '#f1f5f9' : '#0d1b3e',
    sub:      isDark ? '#6b7280' : '#94a3b8',
    inputBg:  isDark ? '#131929' : '#f8fafc',
    inputBdr: isDark ? '#252d45' : '#e2e8f0',
    rowHover: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
    thBg:     isDark ? '#141929' : '#f8fafc',
    thColor:  isDark ? '#64748b' : '#94a3b8',
  };

  /* ── col widths for grid ── */
const gridCols = '44px 1.8fr 1fr 1.4fr 1fr 0.8fr 350px';

  /* ── SortIcon ── */
  const SortIcon = ({ field }) => (
    <span style={{ opacity: sortField===field ? 1 : 0.35, display:'flex', color: sortField===field ? '#1d4ed8' : 'inherit' }}>
      {sortField===field && sortDir==='desc' ? <IconChevronU /> : <IconChevronD />}
    </span>
  );

  return (
    <>
      {copied && <div className="up-copied-toast">✓ User ID copied!</div>}
      {showLogoutModal && (
        <LogoutModal isDark={isDark} onClose={() => setShowLogoutModal(false)} onConfirm={LogoutAllUsers} loading={loadingLogout === true && showLogoutModal} />
      )}

      <style>{`:root { --row-hover: ${C.rowHover}; }`}</style>

      <div style={{ position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0,
        transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        overflowY:'auto', background:C.bg,
        fontFamily:"'DM Sans','Segoe UI',sans-serif",
      }}>
        {/* ── Breadcrumb ── */}
        <div style={{ padding:'12px 28px', background:isDark ? '#141929' : C.bg, display:'flex', alignItems:'center', gap:8, fontSize:12, borderBottom:`1px solid ${C.border}` }}>
          <Link to="/AllLeadsForAdmin" style={{ textDecoration:'none', color:C.sub, fontWeight:500 }}>Home</Link>
          <KeyboardDoubleArrowRightIcon sx={{ fontSize:14, color:C.sub }} />
          <span style={{ color:C.text, fontWeight:600 }}>Users Management</span>
        </div>

        <div style={{ padding:'24px 28px 48px' }}>

          {/* ── Page Header ── */}
          <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:16, marginBottom:24 }}>
            <div>
              <h1 style={{ fontSize:22, fontWeight:800, color:C.text, margin:'0 0 4px', letterSpacing:'-0.4px' }}>Users Management</h1>
              <p style={{ fontSize:13, color:C.sub, margin:0 }}>Manage administrative access and system permissions for your organization.</p>
            </div>
            <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
              {/* Logout All */}
              <button type="button" onClick={() => setShowLogoutModal(true)}
                style={{ padding:'10px 18px', borderRadius:9, border:`1.5px solid ${isDark ? '#3a2a2a' : '#fecaca'}`, background: isDark ? 'rgba(239,68,68,0.08)' : '#fff5f5', color:'#ef4444', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', gap:7, fontFamily:"'DM Sans',sans-serif", transition:'all 0.2s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(239,68,68,0.15)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? 'rgba(239,68,68,0.08)' : '#fff5f5'; }}>
                <IconLogout /> Logout All Users
              </button>
              {/* Add New */}
              <Link to="/Rigister" style={{ textDecoration:'none' }}>
                <button type="button"
                  style={{ padding:'10px 18px', borderRadius:9, border:'none', background:'linear-gradient(135deg,#1e40af,#1d4ed8)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', gap:7, boxShadow:'0 4px 14px rgba(29,78,216,0.35)', fontFamily:"'DM Sans',sans-serif", transition:'all 0.2s' }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 6px 20px rgba(29,78,216,0.45)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 4px 14px rgba(29,78,216,0.35)'; }}>
                  <IconAdd /> Add New User
                </button>
              </Link>
            </div>
          </div>

          {/* ── Filters Bar ── */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:'14px 18px', marginBottom:16, display:'flex', alignItems:'center', gap:12, flexWrap:'wrap', boxShadow: isDark ? 'none' : '0 2px 10px rgba(0,0,0,0.05)' }}>
            {/* Search */}
            <div style={{ position:'relative', flex:'1 1 200px', minWidth:160 }}>
              <span style={{ position:'absolute', left:11, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none' }}><IconSearch /></span>
              <input
                placeholder="Search by name or email..."
                style={{ width:'100%', padding:'8px 12px 8px 34px', borderRadius:8, border:`1.5px solid ${C.inputBdr}`, background:C.inputBg, color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', transition:'border-color 0.15s' }}
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                onFocus={(e) => { e.target.style.borderColor='#2563eb'; e.target.style.boxShadow='0 0 0 3px rgba(37,99,235,0.1)'; }}
                onBlur={(e) => { e.target.style.borderColor=C.inputBdr; e.target.style.boxShadow='none'; }}
              />
            </div>

            {/* Role dropdown */}
            <select className="up-select-sm"
              style={{ border:`1.5px solid ${C.inputBdr}`, background:C.inputBg, color:C.text, flex:'0 0 auto' }}
              value={roleFilter}
              onChange={(e) => { setRoleFilter(e.target.value); setCurrentPage(1); }}>
              <option value="all">All Roles</option>
              {uniqueRoles.map(r => <option key={r} value={r}>{r}</option>)}
            </select>

            {/* Status dropdown */}
            <select className="up-select-sm"
              style={{ border:`1.5px solid ${C.inputBdr}`, background:C.inputBg, color:C.text, flex:'0 0 auto' }}
              value={statusFilter}
              onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }}>
              <option value="all">All Statuses</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>

            {/* Clear */}
            {hasFilters && (
              <button onClick={clearFilters}
                style={{ padding:'8px 14px', borderRadius:8, border:'none', background:'none', color:'#1d4ed8', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' }}>
                Clear Filters
              </button>
            )}

            {/* Stats */}
            <span style={{ marginLeft:'auto', fontSize:12, fontWeight:700, color:C.sub, whiteSpace:'nowrap' }}>
              {filteredUsers.length} USERS TOTAL
            </span>

            {/* Sort by */}
            <div style={{ display:'flex', alignItems:'center', gap:7 }}>
              <span style={{ fontSize:12, color:C.sub, whiteSpace:'nowrap' }}>Sort by:</span>
              <select className="up-select-sm"
                style={{ border:`1.5px solid ${C.inputBdr}`, background:C.inputBg, color:C.text }}
                value={sortField}
                onChange={(e) => { setSortField(e.target.value); setSortDir('asc'); }}>
                <option value="role">Role</option>
                <option value="name">Name</option>
                <option value="email">Email</option>
                <option value="status">Status</option>
              </select>
            </div>
          </div>

          {/* ── Table ── */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, overflow:'hidden', boxShadow: isDark ? 'none' : '0 2px 12px rgba(0,0,0,0.06)' }}>

            {/* Table Head */}
            <div className="up-row" style={{ gridTemplateColumns:gridCols, background:C.thBg, borderBottom:`1px solid ${C.border}`, height:44 }}>
              <div className="up-td" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                <input type="checkbox" className="up-checkbox" checked={allSelected} onChange={toggleAll} />
              </div>
              {[
                { label:'USER',    field:'name'   },
                { label:'ROLE',    field:'role'   },
                { label:'EMAIL',   field:'email'  },
                { label:'PHONE',   field:null     },
                { label:'STATUS',  field:'status' },
                { label:'ACTIONS', field:null     },
              ].map(({ label, field }) => (
                <div key={label} className="up-th" style={{ color:C.thColor }} onClick={() => field && handleSort(field)}>
                  {label}
                  {field && <SortIcon field={field} />}
                </div>
              ))}
            </div>

            {/* Body */}
            {loading ? (
              <div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:280 }}>
                <CircularProgress style={{ color:'#1d4ed8' }} size={36} />
              </div>
            ) : currentUsers.length === 0 ? (
              <div style={{ padding:'56px 24px', textAlign:'center' }}>
                <div style={{ fontSize:40, marginBottom:12 }}>🔍</div>
                <p style={{ fontSize:16, fontWeight:700, color:C.text, margin:'0 0 6px' }}>No Users Found</p>
                <p style={{ fontSize:13, color:C.sub, margin:'0 0 18px' }}>
                  {hasFilters ? 'Try changing your search or filters' : 'No users in the system yet'}
                </p>
                {hasFilters && (
                  <button onClick={clearFilters} style={{ padding:'9px 18px', borderRadius:9, border:`1.5px solid ${C.inputBdr}`, background:'transparent', color:'#1d4ed8', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                    Clear All Filters
                  </button>
                )}
              </div>
            ) : (
              currentUsers.map((user, idx) => {
                const conf       = getRoleConf(user.role);
                const isExpanded = expandedRows.includes(user._id);
                const isSel      = selected.includes(user._id);

                return (
                  <div key={user._id}>
                    {/* ── Row ── */}
                    <div
                      className="up-row"
                      style={{
                        gridTemplateColumns: gridCols,
                        borderBottom: `1px solid ${C.border}`,
                        minHeight: 62,
                        background: isSel ? (isDark ? 'rgba(29,78,216,0.07)' : 'rgba(29,78,216,0.04)') : 'transparent',
                      }}
                    >
                      {/* Checkbox */}
                      <div className="up-td" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <input type="checkbox" className="up-checkbox" checked={isSel} onChange={() => toggleOne(user._id)} />
                      </div>

                      {/* User */}
                      <div className="up-td" style={{ display:'flex', alignItems:'center', gap:11 }}>
                        <div style={{ position:'relative', flexShrink:0 }}>
                          <div style={{ width:38, height:38, borderRadius:10, backgroundColor:conf.initBg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:700, color:'#fff', overflow:'hidden', flexShrink:0 }}>
                            {user.profileImg
                              ? <img src={user.profileImg} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                              : user.name?.charAt(0)?.toUpperCase()}
                          </div>
                          <div style={{ position:'absolute', bottom:-1, right:-1, width:10, height:10, borderRadius:'50%', backgroundColor:user.active ? '#22c55e' : '#ef4444', border:`2px solid ${isDark ? '#1a1f2e' : '#fff'}` }} />
                        </div>
                        <div style={{ minWidth:0 }}>
                          <div style={{ fontSize:13, fontWeight:700, color:C.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{user.name}</div>
                          <div style={{ fontSize:11, color:C.sub, marginTop:1 }}>
                            {user.lastActive ? `Last active: ${user.lastActive}` : user.createdAt ? `Joined: ${new Date(user.createdAt).toLocaleDateString()}` : ''}
                          </div>
                        </div>
                      </div>

                      {/* Role */}
                      <div className="up-td">
                        <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:6, fontSize:11, fontWeight:700, backgroundColor:conf.bg, color:conf.color, border:`1px solid ${conf.border}`, textTransform:'uppercase', letterSpacing:'0.04em' }}>
                          {user.role}
                        </span>
                      </div>

                      {/* Email */}
                      <div className="up-td" style={{ color:C.sub, fontSize:12, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                        {user.email}
                      </div>

                      {/* Phone */}
                      <div className="up-td" style={{ color:C.sub, fontSize:12, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                        {user.phone || <span style={{ color:isDark ? '#374151' : '#d1d5db' }}>—</span>}
                      </div>

                      {/* Status */}
                      <div className="up-td">
                        <span style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:12, fontWeight:600, color: user.active ? '#22c55e' : '#ef4444' }}>
                          <span style={{ width:7, height:7, borderRadius:'50%', background:'currentColor', flexShrink:0 }} />
                          {user.active ? 'Active' : 'Inactive'}
                        </span>
                      </div>

                      {/* Actions */}
                      <div className="up-td" style={{ display:'flex', alignItems:'center', gap:5 }}>
                        {/* Copy ID */}
                        <CopyToClipboard text={user._id} onCopy={() => { setCopied(true); setTimeout(() => setCopied(false), 2000); }}>
                          <button className="up-action-btn" title="Copy ID"
                            style={{ borderColor: isDark ? '#252d45' : '#e2e8f0', color: C.sub }}
                            onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'#252D4A':'#f8fafc'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background='transparent'; }}>
                            <IconCopy />
                          </button>
                        </CopyToClipboard>

                        {/* Edit */}
                        <Link to={`/Register/${user._id}`} className="up-action-btn" title="Edit"
                          style={{ borderColor: isDark?'#1e3a5f':'#dbeafe', color:'#3b82f6', background: isDark?'rgba(59,130,246,0.07)':'rgba(59,130,246,0.06)' }}
                          onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(59,130,246,0.18)':'rgba(59,130,246,0.12)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(59,130,246,0.07)':'rgba(59,130,246,0.06)'; }}>
                          <IconEdit />
                        </Link>

                        {/* Key */}
                        <Link to={`/ChangePassword/${user._id}`} className="up-action-btn" title="Change Password"
                          style={{ borderColor: isDark?'#14532d':'#dcfce7', color:'#22c55e', background: isDark?'rgba(34,197,94,0.07)':'rgba(34,197,94,0.06)' }}
                          onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(34,197,94,0.18)':'rgba(34,197,94,0.12)'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(34,197,94,0.07)':'rgba(34,197,94,0.06)'; }}>
                          <IconKey />
                        </Link>

                        {/* UsersActions (deactivate/delete) */}
                        <UsersActions userid={user._id} getallusers={getallusers} />

                        {/* Channels expand (Marketer only) */}
                        {user.role === 'Marketer' && (
                          <button className="up-action-btn" title="View channels"
                            onClick={() => setExpandedRows(prev => prev.includes(user._id) ? prev.filter(x=>x!==user._id) : [...prev,user._id])}
                            style={{ borderColor:isDark?'#3b1f5e':'#f3e8ff', color:'#a855f7', background:isDark?'rgba(168,85,247,0.07)':'rgba(168,85,247,0.06)' }}
                            onMouseEnter={(e) => { e.currentTarget.style.background=isDark?'rgba(168,85,247,0.18)':'rgba(168,85,247,0.12)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background=isDark?'rgba(168,85,247,0.07)':'rgba(168,85,247,0.06)'; }}>
                            <span style={{ display:'flex', transform:isExpanded?'rotate(180deg)':'none', transition:'transform 0.2s' }}><IconChevronD /></span>
                          </button>
                        )}
                      </div>
                    </div>

                    {/* ── Channels Expanded ── */}
                    {user.role === 'Marketer' && isExpanded && (
                      <div style={{ padding:'14px 20px 18px 20px', background: isDark?'rgba(168,85,247,0.04)':'rgba(168,85,247,0.025)', borderBottom:`1px solid ${C.border}` }}>
                        <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:12 }}>
                          <span style={{ color:'#a855f7', display:'flex' }}><IconChannel /></span>
                          <span style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.07em', color:C.sub }}>Assigned Channels</span>
                        </div>
                        {user.channels && user.channels.length > 0 ? (
                          <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                            {user.channels.map((ch, idx2) => (
                              <div key={ch._id||idx2} className="up-channel-chip" style={{ background:CHANNEL_COLORS[idx2%CHANNEL_COLORS.length] }}>
                                <div style={{ fontWeight:700, fontSize:12, marginBottom:1 }}>{ch.name||ch.channelName||`Channel ${idx2+1}`}</div>
                                {ch.code && <div style={{ fontSize:10, opacity:0.85 }}>Code: {ch.code}</div>}
                                <div style={{ fontSize:10, opacity:0.8, marginTop:1 }}>{ch.active==='true'?'✅ Active':'❌ Inactive'}</div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span style={{ fontSize:12, color:'#ef4444' }}>⚠️ No channels assigned</span>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>

          {/* ── Pagination ── */}
          {totalPages > 1 && (
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12, marginTop:14, background:C.card, border:`1px solid ${C.border}`, borderRadius:12, padding:'12px 18px', boxShadow: isDark?'none':'0 2px 8px rgba(0,0,0,0.05)' }}>
              <span style={{ fontSize:12, color:C.sub }}>
                Showing {startIndex+1}–{Math.min(startIndex+itemsPerPage, filteredUsers.length)} of {filteredUsers.length} users
              </span>

              <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                <button className="up-page-btn" disabled={currentPage===1} onClick={() => setCurrentPage(1)}
                  style={{ borderColor: isDark?'#252d45':'#e2e8f0', color:C.sub }}>«</button>
                <button className="up-page-btn" disabled={currentPage===1} onClick={() => setCurrentPage(p=>p-1)}
                  style={{ borderColor: isDark?'#252d45':'#e2e8f0', color:C.sub }}>‹</button>

                {Array.from({ length: Math.min(5,totalPages) }, (_,i) => {
                  let p;
                  if (totalPages<=5) p=i+1;
                  else if (currentPage<=3) p=i+1;
                  else if (currentPage>=totalPages-2) p=totalPages-4+i;
                  else p=currentPage-2+i;
                  return (
                    <button key={p} className="up-page-btn" onClick={() => setCurrentPage(p)}
                      style={{ borderColor:currentPage===p?'#1d4ed8':(isDark?'#252d45':'#e2e8f0'), background:currentPage===p?'#1d4ed8':'transparent', color:currentPage===p?'#fff':C.sub }}>
                      {p}
                    </button>
                  );
                })}

                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <span style={{ color:C.sub, fontSize:12, padding:'0 4px' }}>…</span>
                )}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <button className="up-page-btn" onClick={() => setCurrentPage(totalPages)}
                    style={{ borderColor:isDark?'#252d45':'#e2e8f0', color:C.sub }}>{totalPages}</button>
                )}

                <button className="up-page-btn" disabled={currentPage===totalPages} onClick={() => setCurrentPage(p=>p+1)}
                  style={{ borderColor:isDark?'#252d45':'#e2e8f0', color:C.sub }}>›</button>
                <button className="up-page-btn" disabled={currentPage===totalPages} onClick={() => setCurrentPage(totalPages)}
                  style={{ borderColor:isDark?'#252d45':'#e2e8f0', color:C.sub }}>»</button>
              </div>

              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ fontSize:12, color:C.sub }}>View</span>
                <select className="up-select-sm"
                  style={{ border:`1.5px solid ${C.inputBdr}`, background:C.inputBg, color:C.text }}
                  value={itemsPerPage}
                  onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                  {[5,10,20,50].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
};
